import React, { useEffect, useState } from 'react'
import MyListBlock from '../../../../UI/list/MyListBlock'
import Status from '../../../../UI/status/Status'
import { getDateAndTimeText } from '../../../../../helpers/date/dateHelper'
import ChangeNakladnaButton from '../../forms/changeNakladna/ChangeNakladnaButton'
import ChangeNakladnaOriginalButton from '../../forms/changeNakladnaOriginal/ChangeNakladnaOriginalButton'
import SupplyBillPriceGeneral from './price/SupplyBillPriceGeneral'
import ChangeStatusBillButton from '../../forms/changeStatus/ChangeStatusBillButton'

const SupplyBillAbout = ({ supplyBill }) => {

    const [list, setList] = useState([])

    useEffect(() => {
        setListItems()
    }, [supplyBill])

    const setListItems = () => {
        const listTemp = []

        listTemp.push({
            name: 'ID',
            value: supplyBill ? supplyBill.id : '-'
        })
        listTemp.push({
            name: 'Статус',
            // value: <Status status={supplyBill.status} />
            value:
                <ChangeStatusBillButton 
                    supplyBill={supplyBill} 
                />
        })
        listTemp.push({
            name: 'Загальна сума',
            value: 
                <SupplyBillPriceGeneral
                    priceAgree={supplyBill.priceAgree}
                />
        })
        listTemp.push({
            name: 'Накладна (наявність)',
            value: 
                <ChangeNakladnaButton
                    supplyBill={supplyBill}
                />
        })
        listTemp.push({
            name: 'Накладна (оригінал)',
            value: 
                <ChangeNakladnaOriginalButton
                    supplyBill={supplyBill}
                />
        })
        listTemp.push({
            name: 'Дата створення',
            value: supplyBill ? getDateAndTimeText(supplyBill.createdAt) : '-'
        })

        setList(listTemp)
    }

  return (
    <MyListBlock 
        className={'supplyOrderView__topBlock'}
        text={'Про рахунок'}
        list={list}
    />
    // <div className='supplyOrderView__about'>
    //     about
    // </div>
  )
}

export default SupplyBillAbout